/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {
  Auth
} from 'aws-amplify'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    // Amplify state + error vars
    authorized: false,
    user: null,
    userAttrs: {},
    isAdmin: false,
    loginError: '',
    signupError: '',
    phoneUpdateError: '',
    phoneVerifyError: '',
    confirm: false,
    confirmError: null,
    confirmEmail: '',
    resendError: '',
    forgotPasswordErr: null,

    // Endpoint + events
    endpoint: process.env.VUE_APP_ENDPOINT,
    ezrEnvironment: process.env.VUE_APP_ENVIRONMENT,
    events: [],

    // State vars for controlling application
    homeURL: true,
    token: null,
    showEvents: false,
    secureHome: true,
    selectedComponent: 'events',
    scrollTo: '',

  },

  mutations: {
    // Amplify mutations
    user(state, user) {
      state.authorized = !!user && user.attributes && user.attributes.email_verified
      state.user = user
    },
    CONFIRM(state, trueOrFalse, email) {
      state.confirm = trueOrFalse
      state.confirmEmail = email
    },
    SECURE_HOME(state, val) {
      state.secureHome = val
    },
    CHANGE_COMPONENT(state, val) {
      state.selectedComponent = val
    },
    HAS_PHONE(state, val) {
      state.hasPhone = val
    },
    VERIFY_PHONE(state) {
      state.phoneVerified = true
    },
    SHOW_EVENTS(state) {
      state.showEvents = true
    },
    SET_LOGGED_IN(state, val) {
      state.loggedIn = val
    },
    SET_USER_ATTRS(state, val) {
      state.userAttrs = val
    },
    SET_EVENTS(state, events) {
      state.events = events
    },
    SET_SCROLL_TO(state, val) {
      state.scrollTo = val
    },
    ADMIN_USER(state, val) {
      state.isAdmin = val
    }
  },

  actions: {
    // Log in a user
    async login({
      dispatch,
      state
    }, {
      email,
      password
    }) {
      console.log('ACTION -> login')
      state.loginError = ''
      try {
        console.log('try signIn')
        await Auth.signIn(email, password)
      } catch (err) {
        console.log(`Login Error [${err}]`)
        if (err)
          state.loginError = err.message || err
        return
      }
      await dispatch('fetchUser')
    },

    // Sign up a user
    async signup({
      commit,
      state
    }, {
      email,
      password,
      name
    }) {
      state.signupError = ''
      try {
        await Auth.signUp({
          username: email,
          email: email,
          password: password,
          attributes: {
            email: email,
            nickname: name,
          },
          validationData: [],
        })
        //switch email confirmation form
        commit('CONFIRM', true, email)
      } catch (err) {
        console.log(`Signup Error [${err}]`)
        if (err)
          state.signupError = err.message || err
        commit('CONFIRM', false, '')
      }
    },

    // Confirm a new user with an email validation code
    async confirm({
      commit,
      state
    }, {
      email,
      code
    }) {
      state.confirmError = ''
      try {
        await Auth.confirmSignUp(email, code, {
          forceAliasCreation: true,
        })
      } catch (err) {
        console.log(`Confirm Error [${err}]`)
        if (err)
          state.confirmError = err.message || err
        return
      }
      commit('CONFIRM', false)
    },

    // Verify a user's authentication state
    async authState({
      commit,
      dispatch
    }, state) {
      if (state === 'signedIn')
        await dispatch('fetchUser')
      else
        commit('user', null)
    },

    // Update/confirm a user's phone number
    async updatePhone({
      commit,
      dispatch,
      state
    }, {
      newPhone
    }) {
      console.log('UPDATEPHONE --> newPhone: ', newPhone)
      try {
        let user = await Auth.currentAuthenticatedUser();
        const newAttr = await Auth.updateUserAttributes(user, {
          'phone_number': '+1' + newPhone
        })
        user = await dispatch('fetchUser')
        commit('user', user)
      } catch (err) {
        console.log('phone update Error: ', err)
        if (err)
          state.phoneUpdateError = err.message || err
        return
      }
    },

    // Get the user's info
    async fetchUser({
      commit,
      dispatch
    }) {
      console.log('ACTION -> fetchUser')
      try {
        const user = await Auth.currentAuthenticatedUser()
        // console.log('user: ', user)
        const attrs = await Auth.currentUserInfo()
        // console.log('attrs: ', attrs)
        const expires = user.getSignInUserSession().getIdToken().payload.exp - Math.floor(new Date().getTime() / 1000)
        // console.log(`Token expires in ${expires} seconds`)
        setTimeout(async () => {
          // console.log('Renewing Token')
          await dispatch('fetchUser')
        }, expires * 1000)
        commit('user', user)
        commit('SET_LOGGED_IN', true)
        commit('SET_USER_ATTRS', attrs)
        dispatch('isAdminUser')
      } catch (err) {
        commit('user', null)
        commit('SET_LOGGED_IN', false)
      }
    },

    // Check if user is admin
    async isAdminUser({
      state,
      commit
    }) {
      let userGroup = state.user.signInUserSession.accessToken
        .payload["cognito:groups"];
      // console.log('userGroup: ', userGroup)

      if (userGroup != undefined && userGroup.includes('admin')) {
        commit('ADMIN_USER', true)
      }
    },

    // Send phone a verification code to verify phone number
    async verifyPhone({
      state,
    }) {
      try {
        await Auth.verifyCurrentUserAttribute('phone_number')
      } catch (err) {
        if (err)
          console.log('phone verify Error: ', err)
        state.phoneVerifyError = err.message || err
        return
      }
    },

    // send phone verification code to AWS
    async verifyPhoneCode({
      state,
      commit,
      dispatch
    }, smsCode) {
      try {
        await Auth.verifyCurrentUserAttributeSubmit('phone_number', smsCode)

        commit('HAS_PHONE', true)
        dispatch('fetchUser')
      } catch (err) {
        console.log('SMS Code verify Error: ', err)
        if (err)
          state.phoneVerifyError = err.message || err
        return
      }
    },

    // Send user a forgot password verification code
    async forgotPasswordInit({
      state
    }, email) {
      try {
        await Auth.forgotPassword(email)
      } catch (err) {
        console.log('Forgot Password Error: ', err)
        if (err)
          state.forgotPasswordErr = err.message || err
        return
      }
    },

    // Submit forgot pw verification code to AWS
    async forgotPasswordSubmit({
      state
    }, {
      email,
      code,
      password
    }) {
      try {
        await Auth.forgotPasswordSubmit(email, code, password)
      } catch (err) {
        console.log('Forgot Password Error: ', err)
        if (err)
          state.forgotPasswordErr = err.message || err
        return
      }
    },

    // Resend signup verification email
    async resendCode({
      state
    }, email) {
      try {
        await Auth.resendSignUp(email)
      } catch (err) {
        console.log('resendCode signup  Error: ', err)
        if (err)
          state.resendError = err.message || err
        return
      }
    },

    // Log out a user
    async logout({
      commit
    }) {
      await Auth.signOut()
      commit('user', null)
      commit('SET_LOGGED_IN', false)
      commit('SECURE_HOME', false)
    },

    // Get events associated with a user
    async getEvents({
      state,
      commit
    }) {
      let phone = state.userAttrs.attributes.phone_number
      let url = 'https://' + state.endpoint + '.execute-api.us-west-2.amazonaws.com/' + state.ezrEnvironment + '/events/?id=' + phone.replace('+', "%2B")

      let res = await axios.get(url)

      // attatch new urls to avoid dynamic src issues in v-fors.
      for (let event of res.data) {
        let numCameras = event.num_devices
        let i = 1
        let cameraData = []

        while (i <= numCameras) {
          let url = 'https://s3-us-west-2.amazonaws.com/ezrelic-videos-2/' + event.event_number + '/camera-' + i + '.mp4'
          let cameraNum = i
          cameraData.push({
            cameraNum,
            url
          })
          i++
        }
        event['cameraData'] = cameraData
      }
      commit('SET_EVENTS', res.data)
    },
  },

  modules: {}
})
